<template>
    <v-dialog v-model="show" max-width="600" persistent no-click-animation>
        <div class="ScenarioCreator">
            <div class="dialog-header">
                <div>Audio Editor</div>
                <v-btn flat icon @click="close()">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>
            <v-form v-model="formValid" ref="form" @submit="submit" style="padding: 12px">
                <div class="label">{{ $f.tc('audio') }}</div>
                <div style="display: flex">
                    <v-text-field
                        label="Selected File"
                        @click="importAudio"
                        v-model="fileName"
                        class="input-custom"
                        v-if="showInput"
                    ></v-text-field>
                    <input
                        type="file"
                        style="display: none"
                        ref="audio"
                        accept="audio/*"
                        @change="handleFile"
                    >
                </div>
            </v-form>
            <div class="dialog-footer">
                <div class="btn-custom"
                     @click="submit">{{ $f.tc('save') }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";

export default {
    name: "AudioEdit",
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            model: {
                id: '',
                name: '',
                audio: '',
                scenario_node_id: '',
                file: null,
            },
            index: null,
            fileName: '',
            showInput: true,
        }
    },
    methods: {
        open(item, index) {
            this.index = index
            if (item) {
                this.model.id = item.id
                this.model.name = item.name
                this.model.audio = item.audio
                this.model.scenario_node_id = item.scenario_node_id
                this.model.file = item.file
            } else {
                this.clearForm()
            }
            this.show = true

            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        close() {
            this.show = false
            this.model = {}
            this.$emit('close')
        },
        submitValidForm() {
            this.$emit('updateAudioUrl', this.model, this.index)
            this.show = false
        },
        // upload audio
        importAudio() {
            this.$refs.audio.click()
        },
        handleFile(event) {
            let file = event.target.files[0]
            let extFile = file.name.split('.').pop()
            if (['wav', 'mp3'].includes(extFile)) {
                this.model.file = file
                this.fileName = file.name
            } else {
                this.$appService.toastError('invalid file')
            }
        },
        changeTypeUploadAudio() {
            this.showInput = !this.showInput
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioCreator {
    background: #FFFFFF;
    position: relative;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-header {
        padding: 0 0 0 12px;
    }
}

.btn-custom {
    margin-right: 8px;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
}
</style>
